import { IngInputBase } from './ing-input-base';

export class IngSelect extends IngInputBase<string> {
  public options: Array<{id: any, text: string}>;
  public multiple: boolean;

  constructor(
    options: {
      value?: string,
      key?: string,
      label?: string,
      description?: string,
      required?: boolean,
      order?: number,
      options?: Array<{id: number, text: string}>,
      multiple?: boolean
      controlType?: string,
      placeHolder?: string,
      classContainer?: string
    } = {}
  ) {
    super(options);

    this.options  = options.options || [];
    this.multiple = options.multiple || false;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/inputs/ing-select.ts